<div class="header">
    <h2>{{ title() }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="all-media-edit-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'media.error.unavailable' | translate" />
} @else if (media(); as media) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
        <div class="section">
            <h2>{{ 'media.fieldset.basic' | translate }}</h2>
            <app-form-input [control]="form.controls.name" [label]="'media.form.name' | translate" inputId="name" testId="all-media-edit-name" />
        </div>

        <div class="section">
            <h2>{{ 'media.fieldset.source' | translate }}</h2>
            <div class="col">
                @if (type() === 'text') {
                    <app-form-wysiwyg
                        [control]="form.controls.content"
                        [label]="'media.form.content' | translate"
                        inputId="content"
                        testId="all-media-edit-content"
                    />
                    <app-form-number
                        [control]="form.controls.duration"
                        [label]="'media.form.duration' | translate"
                        inputId="duration"
                        testId="all-media-edit-duration"
                    />
                } @else {
                    <app-form-file-upload
                        [control]="form.controls.mediaId"
                        [label]="'media.form.file' | translate"
                        [type]="type()"
                        [accept]="fileAccept()"
                        [aspectRatio]="type() === 'video' ? '16/9' : null"
                        inputId="file"
                        testId="all-media-edit-file"
                    />
                }
            </div>
        </div>
    </form>

    <div class="footer">
        <p-button [label]="'media.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="all-media-edit-cancel" (onClick)="close()" />
        <p-button
            type="submit"
            [label]="'media.form.save' | translate"
            [loading]="saving()"
            [disabled]="form.disabled"
            data-test="all-media-edit-save"
            (onClick)="onSubmit()"
        />
    </div>
}
